import { lazy, Suspense } from 'react'

// StatisticsPage pulls echarts (~hundreds of KB). Lazy-load it so that
// weight lands in its own chunk instead of the shared bundle — operators
// never hit /staff/statistics and shouldn't pay for it. Kept in its own
// file so routes/index.tsx stays free of component definitions
// (react-refresh/only-export-components).
const StatisticsPage = lazy(() =>
  import('./StatisticsPage').then((m) => ({ default: m.StatisticsPage })),
)

export function StatisticsPageLazy() {
  return (
    <Suspense
      fallback={
        <div className="py-20 text-center text-gray-400 dark:text-gray-500">
          Загрузка…
        </div>
      }
    >
      <StatisticsPage />
    </Suspense>
  )
}
